<template>
  <div class="allBottom" style="position: relative">
    <div class="bottomContent">
      <!-- <a class="map" href="./sitemap.html">网站地图</a> -->
      <a class="xy" @click="go('1')">用户协议</a>

      <a class="ys" style="margin-right: 15px" @click="go('2')">隐私政策</a>
      <a class="xy" @click="go('3')">版权保护申诉指引</a>
      <a class="ys" @click="go('1')">平台规则</a>
      <a class="ys" @click="go('5')">美术作品合作协议</a>
      <p style="margin: 25px 0">广州漫图软件科技有限公司</p>

      <p>
        Copyright © 2024
        <a style="margin-left: 20px; color: #e5e5e5" href="http://beian.miit.gov.cn/">粤ICP备2024170096号</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <!-- 粤网文（2024）1785-133号 -->
      </p>
      <div style="width: 300px; margin: 0 auto; padding: 20px 0 0"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    go (id) {
      this.$router.push({
        path: '/agreement',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
.allBottom {
  width: 100%;
  /* height: 225px; */
  background: #3c4052;
}
.allBottom .bottomContent {
  width: 900px;
  margin: 0 auto;
  height: 100%;
  text-align: center;
  font-size: 14px;
  color: #e5e5e5;
  /* padding-top: 60px; */
  padding-top: 46px;
  box-sizing: border-box;
}
.allBottom .bottomContent .map {
  font-size: 12px;
  color: #ccc;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}
.allBottom .bottomContent .xy {
  font-size: 12px;
  color: #ccc;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 15px;
  margin-right: 15px;
}
.allBottom .bottomContent .ys {
  font-size: 12px;
  color: #ccc;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
  margin-left: 15px;
}
</style>
